import React from 'react';
import './ImageZoomModal.css';

export interface ImageZoomModalProps {
  isOpen: boolean;
  imageUrl?: string;
  imageData?: string;
  onClose: () => void;
}

const ImageZoomModal: React.FC<ImageZoomModalProps> = ({
  isOpen,
  imageUrl,
  imageData,
  onClose,
}) => {
  const imageSrc = imageUrl || (imageData ? `data:image/png;base64,${imageData}` : '');

  if (!isOpen || !imageSrc) return null;

  return (
    <div className={`zoom-modal ${isOpen ? 'zoom-modal--open' : ''}`} onClick={onClose}>
      <button className="zoom-close-button" onClick={onClose}>
        ✕
      </button>
      <img
        className="zoomed-image"
        src={imageSrc}
        alt="AI Kombin Önerisi - Büyütülmüş"
        onClick={(e) => e.stopPropagation()}
      />
    </div>
  );
};

export default ImageZoomModal;

